// 静态媒体资源（图标/视频），文案统一走 i18n（home.problems / home.services / home.partners）
export const serviceMedia = [
  {
    icon: require('@a/images/home/part1.png'),
    iconYel: require('@a/images/home/party1.png'),
    detailImg: require('@a/images/home/tosee.png'),
    id: 1,
    videoUrl: 'https://xiaowu-web.oss-cn-beijing.aliyuncs.com/video/%E5%8D%96%E7%82%B9%E8%A7%86%E9%A2%91/%E4%B8%80%E9%94%AE%E5%88%86%E5%8F%91.mp4',
  },
  {
    icon: require('@a/images/home/part2.png'),
    iconYel: require('@a/images/home/party2.png'),
    detailImg: require('@a/images/home/tosee.png'),
    id: 2,
    videoUrl: 'https://xiaowu-web.oss-cn-beijing.aliyuncs.com/video/%E5%8D%96%E7%82%B9%E8%A7%86%E9%A2%91/%E6%99%BA%E8%83%BD%E7%89%88%E6%9D%83.mp4',
  },
  {
    icon: require('@a/images/home/part3.png'),
    iconYel: require('@a/images/home/party3.png'),
    detailImg: require('@a/images/home/tosee.png'),
    id: 3,
    videoUrl: 'https://xiaowu-web.oss-cn-beijing.aliyuncs.com/video/%E5%8D%96%E7%82%B9%E8%A7%86%E9%A2%91/%E5%8F%AF%E8%A7%86%E5%8C%96%E6%94%B6%E7%9B%8A.mp4',
  },
  {
    icon: require('@a/images/home/part4.png'),
    iconYel: require('@a/images/home/party4.png'),
    detailImg: require('@a/images/home/tosee.png'),
    id: 4,
    videoUrl: 'https://xiaowu-web.oss-cn-beijing.aliyuncs.com/video/%E5%8D%96%E7%82%B9%E8%A7%86%E9%A2%91/%E8%BF%90%E8%90%A5%E4%B8%93%E5%AE%B6.mp4',
  },
  {
    icon: require('@a/images/home/part5.png'),
    iconYel: require('@a/images/home/party5.png'),
    detailImg: require('@a/images/home/tosee.png'),
    id: 5,
    videoUrl: 'https://xiaowu-web.oss-cn-beijing.aliyuncs.com/video/%E5%87%BA%E6%B5%B7%E9%80%9A5(1).mp4',
  },
]

export const partnerMedia = [
  { img: require('@a/images/home/person1.png') },
  { img: require('@a/images/home/person2.png') },
  { img: require('@a/images/home/person3.png') },
]
